import React, { Fragment } from 'react'
import Avatar from '@components/avatar'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Bell } from 'react-feather'
import { usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import logo from '@src/assets/images/logo/logo_rg.png'
import { Badge, DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown } from 'reactstrap'

const NotificationDropdown = () => {
    const { auth: { user } } = usePage().props
    const notifications = user.unread_notifications

    const handleNotificationClick = (e, notification) => {
        e.preventDefault()
        Inertia.post(route('notifications.read', notification.id), {}, {
            preserveScroll: true,
            onSuccess: () => {
                if (notification.data?.url) {
                    window.location.href = notification.data.url
                }
            },
        })
    }

    const getAvatarProps = (item) => {
        if (item.img) {
            return { img: item.img, imgHeight: 32, imgWidth: 32 }
        } else if (item.avatarContent) {
            return { content: item.avatarContent, color: item.color }
        } else if (item.avatarIcon) {
            return { icon: item.avatarIcon, color: item.color }
        } else {
            return { img: logo, style: { backgroundColor: 'transparent' } }
        }
    }

    const getNotificationContent = (item) => {
        if (item.content) {
            return item.content
        }
        if (item.message) {
            return `<p class='media-heading'>${item.message}</p>`
        }
        return ''
    }

    return (
        <UncontrolledDropdown tag='li' className='dropdown-notification nav-item me-25'>
            <DropdownToggle tag='a' className='nav-link' href='/' onClick={e => e.preventDefault()}>
                <Bell size={21} className='ficon' />
                {notifications?.length > 0 && (
                    <Badge pill color='danger' className='badge-up'>
                        {notifications.length}
                    </Badge>
                )}
            </DropdownToggle>

            <DropdownMenu end tag='ul' className='dropdown-menu-media mt-0'>
                <li className='dropdown-menu-header'>
                    <DropdownItem className='d-flex' tag='div' header>
                        <h4 className='notification-title mb-0 me-auto'>Notifications</h4>
                        {notifications?.length > 0 && (
                            <Badge tag='div' color='light-primary' pill>
                                {notifications.length} New
                            </Badge>
                        )}
                    </DropdownItem>
                </li>

                <PerfectScrollbar
                    component='li'
                    className='media-list scrollable-container'
                    options={{ wheelPropagation: false }}
                >
                    {notifications.map((notification, index) => {
                        const item = notification.data
                        const avatarProps = getAvatarProps(item)

                        return (
                            <a
                                key={index}
                                className='d-flex'
                                href={item.url ?? '/'}
                                onClick={(e) => handleNotificationClick(e, notification)}
                            >
                                <div className='list-item d-flex align-items-start'>
                                    <div className='me-1'>
                                        <Avatar {...avatarProps} />
                                    </div>

                                    <div
                                        className='list-item-body flex-grow-1'
                                        dangerouslySetInnerHTML={{ __html: getNotificationContent(item) }}
                                    />
                                </div>
                            </a>
                        );
                    })}
                </PerfectScrollbar>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default NotificationDropdown
